/*
 * Texts for deleting an email on the Mail page (QA batch 19, MAIL-014). The
 * window used to read "Delete?" / "Message text" and always closed as if the
 * email was deleted.
 */

export const deleteEmailText = (permanent: boolean) =>
  permanent
    ? {
        title: "Delete this email permanently?",
        body: "This email is in your Deleted folder. Deleting it removes it from your mailbox for good. This can't be undone.",
        confirm: "Delete permanently",
      }
    : {
        title: "Delete this email?",
        body: "The email will be moved to your mailbox's Deleted folder.",
        confirm: "Delete",
      };

const MAILBOX_TEXT = "try authorizing again";

/** What to tell the person when the server didn't delete the email. */
export const deleteFailureText = (error: unknown): string => {
  const e = (error || {}) as { status?: unknown; data?: unknown };
  const data = typeof e.data === "string" ? e.data.trim() : "";
  if (data.toLowerCase().includes(MAILBOX_TEXT))
    return "Your mailbox isn't connected (or the connection has expired). Reconnect it on the Email page, then try again.";
  if (e.status === 403)
    return "You can only delete emails in your own mailbox.";
  // The server answers plain sentences (e.g. the provider kept the email in Deleted).
  if (data && data.length <= 400 && !/exception|\n\s+at /i.test(data))
    return data;
  return "The email wasn't deleted. Please try again.";
};
